import { CDK_REDIRECT_URL } from 'app/App';
import { EXPRESS_API } from 'configs/api/expressApi';
import { WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { useAuth } from 'lib/context';
import { useEffect } from 'react';
import { isCdkEnvironment } from 'configs/api/enviroments';

export const useGlobalAxiosErrorHandler = () => {
  const { whitelabel, logoutUser } = useAuth();

  useEffect(() => {
    const responseInterceptor = EXPRESS_API.interceptors.response.use(
      res => res,
      err => {
        const status = err.response?.status;
        if (status === 401 && isCdkEnvironment) {
          window.location.href = CDK_REDIRECT_URL;
          return;
        }
        if (status === 401) {
          logoutUser({
            redirect: whitelabel?.name === WHITELABEL_NAME.COVIDEO,
          });
        }

        return Promise.reject(err);
      }
    );

    return () => {
      EXPRESS_API.interceptors.response.eject(responseInterceptor);
    };
  }, [whitelabel]);
};
